import { AppContextProps } from "../AppContext";
import InputDialogBase, { InputDialogBaseProps } from "./InputDialogBase";

export class InputDialog {

  static Show(ctx: AppContextProps | null, message: string, title: string,
    dflt_value: string,
    props?: Omit<InputDialogBaseProps, 'open'>) {

    const dailog = ctx?.ShowDialog(InputDialogBase, {

      title: title,
      message: message,

      dflt_value: dflt_value,

      fullWidth: true,

      yesText: "確定",
      yesButtonProps: { variant: 'contained' },

      cancelText: "取消",
      cancelButtonProps: { color: 'inherit' },

      ...props,

      onDialogResult(e) {// 注意! 要放在 ...props 後面覆寫事件

        props?.onDialogResult?.(e);

        if (e.IsCancelClose !== true) {
          dailog?.destroy();
          return
        }
      }
    });
  }

}